import { useDataValue } from 'Simple/Data.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'

export function useOnClick(props) {
  let action = useDataValue({
    context: 'option',
    viewPath: props.viewPath,
    path: 'id',
  })

  let setFlowTo = useSetFlowTo(props.viewPath)

  return async function onClick() {
    switch (action) {
      case 'REMOVE_SUBSCRIBERS': {
        setFlowTo(normalizePath(props.viewPath, '../../../DeleteModal/Content'))
        break
      }
      default: {
        break
      }
    }
  }
}

export function getText(text, list) {
  return text.replace('{}', ` ${list.length} `)
}
